module.exports = __webpack_public_path__ + "static/media/43.7121ad8d.png";